import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, InjectReactive } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { getCatalog, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
let fillIn = class fillIn extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.catalogList = [];
    this.editSortDialogKey = Math.random();
    this.postForm = {
      title: "请填下本项内容",
      required: "1",
      coontent: "",
      itemScore: 0,
      rightText: "",
      scoreRule: "",
      catalogIds: [],
      whetherJoinQuestionBank: false,
      jsonConfig: {
        showIndex: true,
        inputForm: "NONE",
        duplicateCheck: false,
        inputNumberMin: "",
        inputNumberMax: "",
        inputNumberPrecision: "",
        inputMin: "",
        inputMax: ""
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      coontent: [{
        required: false,
        type: "string",
        trigger: "blur"
      }],
      itemScore: [{
        required: true,
        message: "请填写题目分值",
        trigger: "blur"
      }],
      rightText: [{
        required: true,
        message: "请填写答案",
        trigger: "blur"
      }],
      scoreRule: [{
        required: true,
        message: "请选择得分规则",
        trigger: "blur"
      }],
      // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
      whetherJoinQuestionBank: [{
        required: true,
        message: "请选择是否加入题库",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      // 兼容旧数据：补"是否参与查重"默认值；用 $set 保证响应式，避免新增题目时点击后选中状态异常
      if (this.postForm.jsonConfig && this.postForm.jsonConfig.duplicateCheck === undefined) {
        this.$set(this.postForm.jsonConfig, "duplicateCheck", false);
      }
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  remoteMethod(query) {
    this.loading = true;
    getCatalog({
      ...this.basicParams,
      name: query,
      pageSize: 50,
      pageNum: 1
    }).then(res => {
      this.catalogList = res.rows || [];
    }).finally(() => this.loading = false);
  }
  catalogFocus() {
    if (this.catalogList.length === 0) {
      this.remoteMethod();
    }
  }
  openSortDialog() {
    this.$refs.editSortDialog.onShow({
      isBusinessTypeDisable: true,
      formData: {
        businessType: this.questionnaireType
      }
    });
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], fillIn.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], fillIn.prototype, "disabled", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], fillIn.prototype, "activityQuestionnaireProperty", void 0);
__decorate([InjectReactive()], fillIn.prototype, "activitySource", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], fillIn.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], fillIn.prototype, "watchPostForm", null);
fillIn = __decorate([Component({
  name: "fillIn",
  components: {
    questionSettingTemplate,
    EditSortDialog
  }
})], fillIn);
export default fillIn;